import React from "react";
import CollapsibleHeader from "./CollapsibleHeader";

const MobileHeaderToggle = ({ children, defaultOpen = false }) => {
  return (
    <CollapsibleHeader
      title="Header"
      defaultOpen={defaultOpen}
      contentClassName="mt-0"
      className="w-full"
    >
      {children}
    </CollapsibleHeader>
  );
};

export default MobileHeaderToggle;
